import qs from 'qs';
import 'regenerator-runtime/runtime';
import { Achievements } from './components/Achievements/Achievements';
import { Gender } from './components/Gender/Gender';
import { CAT, MEDIA_SERVER, BOT_LINK, CSRF, DATA_ONE, DATA_TWO, DESCRIPTION } from './constants/data';
import fetch from 'isomorphic-fetch';
import { Button } from './components/Button/Button';
import { BackImage } from './components/BackImage/BackImage';
import { CatSkeen } from './components/CatSkeen/CatSkeen';
import { Counts } from './components/Counts/Counts';
import {
  AvatarImg,
  Box,
  NameBlock,
  GenderLabel,
  NameLabel,
  ActionsBox,
  ActionBox,
  DescriptionBox,
  DescriptionHeader
} from './styles';
import { useEffect, useState } from 'react';
import { Cat } from './types';
import { Like } from './components/Like/Like';

const prepareName = (name: string) => {
  if (name.length < 40) {
    return name;
  }

  return name.slice(0, 40);
}

function App() {
  const [cat, setCat] = useState<Cat | undefined>(CAT);
  const [isLikeAllow, setShowLike] = useState<boolean | null>(null);

  useEffect(() => {
    if (!cat) {
      return;
    }

    try {
      const result = window.localStorage.getItem('catbot_likes');

      if (!result) {
        setShowLike(true);

        return;
      }

      const parsed = JSON.parse(result);

      if (Array.isArray(parsed) && parsed.includes(cat.id)) {
        setShowLike(false);
      } else {
        setShowLike(true);
      }
    } catch {
      setShowLike(true);
    }
  // eslint-disable-next-line
  }, [])

  const handleClickLike = async () => {
    if (!cat) {
      return;
    }

    const gen1 = function* (key: number) {
      let iter = key;

      while (true) {
        iter = ((iter * 3) - 5) % 62;

        yield Math.abs(iter);
      }
    }

    const prepareLetter = (str: string, num: number, reverse?: boolean) => {
      if (!str) {
        throw new Error();
      }

      const charcode = reverse ? (str[0].charCodeAt(0)) - num : (str[0].charCodeAt(0)) + num;
      return String.fromCharCode(charcode);
    }

    // @ts-ignore
    const tmp = typeof window.secre === 'function' ? window.secre(DATA_ONE, DATA_TWO) : ''
    const code: string = tmp;

    const response = await fetch('/cats/api/like', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': CSRF || ''
      },
      body: JSON.stringify({
        catId: cat.id,
        code: [...code].reduce<{ value: string; gen: ReturnType<typeof gen1> }>((acc, letter) => {
          const offset = acc.gen.next();
  
          acc.value += prepareLetter(letter, offset.value, true);
  
          return acc;
        }, { value: '', gen: gen1(cat?.id[0].charCodeAt(0) || 0) }).value
      })
    });

    const { items } = await response.json();

    if (!Array.isArray(items) || !items[0]) {
      return;
    }

    const newCat = items[0];
    const result = window.localStorage.getItem('catbot_likes');

    if (!result) {
      window.localStorage.setItem('catbot_likes', JSON.stringify([newCat.id]));
    } else {
      const parsed = JSON.parse(result);

      if (!Array.isArray(parsed)) {
        window.localStorage.setItem('catbot_likes', JSON.stringify([newCat.id]));
      } else {
        if (!parsed.includes(cat.id)) {
          parsed.push(cat.id);

          window.localStorage.setItem('catbot_likes', JSON.stringify(parsed));
        }
      }
    }

    setShowLike(false);
    setCat(newCat);
  }

  const handleClickGoToBot = () => {
    if (BOT_LINK) {
      if (cat) {
        const query = qs.stringify({ start: `r${cat.id}` });

        window.location.href = BOT_LINK + '?' + query;
      } else {
        window.location.href = BOT_LINK;
      }
    }
  }

  if (!cat) {
    return (
      <Box>
        <ActionsBox>
          <ActionBox>
            <GenderLabel>
              С&nbsp;этим котиком что-то не&nbsp;так {`:(`}
            </GenderLabel>
          </ActionBox>
          <ActionBox>
            <Button onClick={handleClickGoToBot}>Перейти в&nbsp;ботика</Button>
          </ActionBox>
        </ActionsBox>
      </Box>
    );
  };

  return (
    <Box>
      <BackImage />
      <CatSkeen catId={cat.id} />
      <AvatarImg $src={MEDIA_SERVER + cat.avatar}>
        <Achievements cat={cat} />
        <Gender gender={cat.gender} />
      </AvatarImg>
      <NameBlock>
        <NameLabel>
          {prepareName(cat.name)}
        </NameLabel>
        <Counts cat={cat} />
      </NameBlock>
      <ActionsBox>
        <ActionBox>
          {typeof isLikeAllow === 'boolean' && <Like active={!isLikeAllow} />}
          <Button disabled={!isLikeAllow} onClick={handleClickLike}>Лайк</Button>
        </ActionBox>
        <ActionBox>
          <Button onClick={handleClickGoToBot}>Добавить в&nbsp;друзья</Button>
        </ActionBox>
      </ActionsBox>
      <DescriptionHeader>
        Описание котика
      </DescriptionHeader>
      <DescriptionBox>
        {DESCRIPTION || <span>У&nbsp;котика пока нет описания</span>}
      </DescriptionBox>
    </Box>
  );
}

export default App;
